// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { createContext, useContext } from 'react';
export const GroupedControlContext = createContext({
    position: null,
    direction: 'horizontal',
    endAction: false,
});
export function useGroupedControlContext() {
    return useContext(GroupedControlContext);
}
/**
 * Resets the grouped-control context back to "not in a group" for a subtree.
 *
 * Controls that render caller-supplied content (for example, custom dropdown
 * content) should wrap that content with this provider. Otherwise a nested
 * control rendered inside such a slot would inherit the surrounding group's
 * `position` and incorrectly pick up the grouped-control styling
 * where adjacent borders lose their border radii.
 */
export function ResetGroupedControlContext({ children }) {
    const { direction } = useGroupedControlContext();
    return (React.createElement(GroupedControlContext.Provider, { value: { position: null, direction } }, children));
}
//# sourceMappingURL=control-group-context.js.map